import React, { useEffect, useState } from 'react'
import { InputField, Text } from '@vatom/wombo'
import { Flex, Pressable } from 'native-base'

import ProcessButton from '../../partials/ProcessButton'

interface ICustomAddress {
  mintAddress: string
  setMintAddress: (address: string) => void
  onMint: () => void
  onSetState: () => void
  isLoading: boolean
}

export const CustomAddress = ({
  onMint,
  onSetState,
  mintAddress,
  setMintAddress,
  isLoading
}: ICustomAddress) => {
  const [isMintDisabled, setIsMintDisabled] = useState(true)

  useEffect(() => {
    if (!/^(0x)?[0-9a-f]{40}$/i.test(mintAddress)) {
      setIsMintDisabled(true)
    } else if (/^(0x)?[0-9a-fA-F]{40}$/.test(mintAddress)) {
      setIsMintDisabled(false)
    }
  }, [mintAddress])

  return (
    <>
      <Flex flex={1}>
        <>
          <Text
            marginTop="28px"
            marginBottom="3px"
            lineHeight="18px"
            fontSize="13px"
            fontFamily="Inter-SemiBold"
          >
            BlockChain Address
          </Text>
          <InputField value={mintAddress} onChangeText={setMintAddress} placeholder="Ox address" />
        </>
      </Flex>
      <ProcessButton
        label="Mint NFT"
        isDisabled={isMintDisabled || isLoading}
        onPress={onMint}
        isLoading={isLoading}
      />
      <Pressable onPress={onSetState} accessibilityRole="button" py="10px">
        <Text
          fontFamily="Inter-Regular"
          fontSize="13px"
          lineHeight="18px"
          color="lightBlue.500"
          textAlign="center"
        >
          I would like to mint to one of my wallets.`
        </Text>
      </Pressable>
    </>
  )
}
export default CustomAddress
